/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon16Light = forwardRef('DataChartBarsAUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 3.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9Z" }),
        React.createElement("path", { d: "M9.5 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M7 7.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5Z" }),
        React.createElement("path", { d: "M4 9.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Z" })));
});
